import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUniledBlack = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 298.37 75",
	style: { enableBackground: "new 0 0 298.37 75" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", {}), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M127.03,0v75h146.95V0H127.03z M270.98,72H130.03V3h140.95V72z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "st0",
			points: "167.82,51.27 156.52,51.27 156.52,18.28 150.71,18.28 150.71,56.72 167.82,56.72  "
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "st0",
			points: "205.74,51.27 190.33,51.27 190.33,38.42 205.29,38.42 205.29,32.97 190.33,32.97 190.33,23.73  205.74,23.73 205.74,18.28 184.52,18.28 184.52,56.72 205.74,56.72  "
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M239.57,55.65c2.28-0.71,4.45-1.98,6.53-3.81c4.13-3.65,6.2-8.43,6.2-14.34c0-5.89-1.98-10.65-5.95-14.27 c-1.96-1.79-4.14-3.06-6.55-3.81c-2.24-0.76-5.29-1.14-9.16-1.14h-8.07v38.45h7.97C234.43,56.72,237.44,56.37,239.57,55.65z  M228.36,23.73h2.62c4.95,0,8.69,1.17,11.23,3.51c2.82,2.62,4.23,6.04,4.23,10.26c0,4.18-1.43,7.58-4.28,10.18 c-1.39,1.26-2.96,2.18-4.68,2.76c-1.73,0.55-3.89,0.82-6.5,0.82h-2.62V23.73z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M22.66,41.07c0,3.35-0.54,5.76-1.62,7.24c-1.61,2.21-3.88,3.31-6.82,3.31c-2.92,0-5.19-1.1-6.8-3.31 c-1.08-1.53-1.62-3.94-1.62-7.24V17.93H0v24.75c0,4.05,1.26,7.39,3.79,10.01c2.82,2.92,6.3,4.38,10.43,4.38 c4.13,0,7.62-1.46,10.46-4.38c2.52-2.62,3.79-5.96,3.79-10.01V17.93h-5.8V41.07z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "st0",
			points: "74.92,42.92 46.88,17.92 46.88,56.38 52.68,56.38 52.68,31.05 80.72,56.38 80.72,17.93 74.92,17.93  "
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 101.13,
			y: 17.93,
			className: "st0",
			width: 5.8,
			height: 38.45
		})
	] })]
});
export default SvgUniledBlack;
